var gst_regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
var gst_lines='';




//const for locationDistrictMap
const locationDistrictMap = {
            36055302: {name: 'bangalore',pincode:'560054', etd:null},
            104755822895:{name:'ahmedabad',pincode:'380052',etd:null},
            104710504751:{name:'mumbai',pincode:'400007',etd:null},
            104710308143:{name:'delhi',pincode:'110019',etd:null}
          };

//const for locally_available_warehouse_pincode
const locally_available_warehouse_pincode="560054,400007,110019,380052";
// Arrays for formatting the date
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

//getDistance for pincode
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const radius = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2-lat1); // deg2rad below
  const dLon = deg2rad(lon2-lon1);
  const a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const d = radius * c; // Distance in km
  return d;
}

// fetch Pincode List for Heavy Weight Order
const Heavy_WEIGHT_PINCODE_URL = "https://cdn.shopify.com/s/files/1/1780/7915/files/PinCodeListHeavyProduct?v=1748266443";


// Cache to avoid refetching
let pincodeArray = null;

// Fetch and parse the array from the .txt file
async function heavyWeightFetchPincodes() {
  const res = await fetch(Heavy_WEIGHT_PINCODE_URL, { cache: "force-cache" });
  if (!res.ok) throw new Error("Failed to fetch pincode data.");

  const text = await res.text();

  // Convert string to array safely
  // Replace single quotes with double quotes to allow JSON.parse
  const jsonReady = text.replace(/'/g, '"');

  // Parse the array
  pincodeArray = JSON.parse(jsonReady);
  return pincodeArray;
}
// Check if a Heavy Weight Pincode Exists
async function isHeavyWeightPincodeAvailable(inputPin) {
  if (!pincodeArray) await heavyWeightFetchPincodes();
  const pin = String(inputPin).trim();
  return pincodeArray.includes(pin);
}

function getNextValidDateLabel(startDateStr, holidayList) {
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const startDate = new Date(startDateStr);

  // Normalize holidays to string form for comparison
  const holidays = new Set(
    holidayList.map(date => new Date(date).toDateString())
  );

  let nextDate = new Date(startDate);
  nextDate.setDate(nextDate.getDate() + 1); // start from the next day

  // Loop until not Sunday and not a holiday
  while (nextDate.getDay() === 0 || holidays.has(nextDate.toDateString())) {
    nextDate.setDate(nextDate.getDate() + 1);
  }

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  if (nextDate.toDateString() === today.toDateString()) {
    return "Today";
  } else if (nextDate.toDateString() === tomorrow.toDateString()) {
    return "Tomorrow";
  } else {
    return days[nextDate.getDay()] + ", " + months[nextDate.getMonth()] + " " + nextDate.getDate();
  }
}











//Dependency of getDistance function
function deg2rad(deg) {
  return deg * (Math.PI/180);
}



async function getPincodeDetails(count1){
        var count=count1;
        var pincodeDetailsData,holiday_list;
        // API URL with query parameters
        const apiCall = "/apps/trackorder/checkProductAvailableLocation?q="+$("#textpincodevalue").val()+"&productId="+document.getElementById('pincodeContainer').title+"&lst="+locally_available_warehouse_pincode;
      
        let enteredPincode=$("#textpincodevalue").val();
        const found_pincode_in_heavy= await isHeavyWeightPincodeAvailable(enteredPincode)
                      console.log("Heavy Weight PincodeCheck")
                      console.log(found_pincode_in_heavy)
        
        // START: SETUP variables of cut-off time for same day dispatch or not
        // Step 1: Get current time
        var currentTime = new Date();
        
        // Step 2: Convert to IST
        var currentOffset = currentTime.getTimezoneOffset(); // Get local timezone offset in minutes
        var ISTOffset = 330; // IST offset is UTC +5:30 (330 minutes)
        var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000); // Convert to IST
        
        // Step 3: Set cut-off time to 2:00 PM IST
        let cutOffTime = new Date(ISTTime);
        cutOffTime.setHours(14); // 2:00 PM
        cutOffTime.setMinutes(0);
        cutOffTime.setSeconds(0);
        cutOffTime.setMilliseconds(0);
        
        // Step 4: Calculate remaining time until cut-off
        let offsetTime = 16 - ISTTime.getHours(); // Not used in the final logic
        let cutOffTimeLeft = "";
        
        // Handle cut-off time
        if (cutOffTime.getHours() > ISTTime.getHours()) {
          // If current time is before cut-off time
          if (cutOffTime.getHours() - ISTTime.getHours() <= 1) {
            // If less than or equal to 1 hour left
            cutOffTimeLeft = (60 - ISTTime.getMinutes()) + " min";
          } else {
            // If more than 1 hour left
            cutOffTimeLeft = (cutOffTime.getHours() - ISTTime.getHours()) + " hr";
          }
        } else {
          // If current time is after cut-off time
          console.log("Cutoff crossed");
        }
                  // END: SETUP variables of cut-off time for same day dispatch or not
    // Validate pincode must be 6 numbers only, without shooting API
    if (enteredPincode.length != 6) {
         // Alert if pincode is not entered at all
         if (enteredPincode.length == 0) {
           $("#ResponsePin").html(
             '<div class="NotAva"></div>'
           );
         }
       // If wrong pincode is entered ( 0 < characters < 6)            
        else {
          $("#ResponsePin").html(
            // '<div class="NotAva"><p >Looks like wrong pincode.</p></div>'
            '<div class="NotAva pincodeMsg"><span style="color: maroon;">Looks like wrong pincode.</span></div><br>'
           );
        }
     }
          // If pincode is 6 digits number, let us process API's response
      else {
           // console.log(apiCall) 
           $.when(ajaxPin(apiCall, pageTemplate)).then(
              (data) => {
                
               //console.log(data);
               pincodeDetailsData=data;
               holiday_list=data.pickuppincode_details.holiday_list;
              
               let isLocallyAvailable=false,availableLocations={},enteredDistrict='N/A',enteredState='N/A';
            try{
              // // Step 1: Filter available inventory
              // const availableInventory = data.inventory.Inventory.filter(item => item.available > 0);
              // console.log('Available Inventory',availableInventory)
              // // Step 2: Map location IDs to pincodes
              //  availableLocations = availableInventory.map(item => ({
              //   locationId: item.location_id,
              //   pincode: locationDistrictMap[item.location_id].pincode,
              //   city: locationDistrictMap[item.location_id].name,
              //   available: item.available
              // }));    
               
              let availableInventory = data.inventory.Inventory || [];

              availableLocations = availableInventory.map(item => ({
                locationId: item.location_id,
                pincode: locationDistrictMap[item.location_id]?.pincode || "",
                city: locationDistrictMap[item.location_id]?.name || "",
                available: item.available
              }));

              console.log(availableLocations)

                           
            // Step 3: Check local availability
             enteredDistrict = data.pickuppincode_details.District;
             enteredState = data.pickuppincode_details.State;
            
            isLocallyAvailable = availableLocations.some(location => {
              const warehouse = data.wh.find(wh => wh.Pincode === location.pincode);
              return (
                warehouse.District === enteredDistrict ||
                (enteredState === "DELHI" && warehouse.State === "DELHI")
              );
            });
            }catch{
              isLocallyAvailable=false;
            }
            const holidays111 = new Set(holiday_list.map(date => new Date(date).toDateString()));
            console.log("Printing Today Day")
            console.log(holidays111.has(currentTime.toDateString()))
            console.log("i am1",isLocallyAvailable,currentTime,holiday_list)
            if(isLocallyAvailable == true  && currentTime.getDay() != 6  ){
                      let valid_date=getNextValidDateLabel(currentTime, holiday_list);
                      console.log(valid_date)
                      let checkDate= new Date();
                      checkDate.setDate(currentTime.getDate() + 1)
                      if ( currentTime.getDay() != 0 && cutOffTimeLeft != "" && holidays111.has(currentTime.toDateString()) == false ) { // local = true, today != sunday, cut off pending
                          console.log(`${cutOffTimeLeft}  for same day delivery` )
                          console.log(checkDate)
                         // console.log(cutOffTime.getHours() - ISTTime.getHours() -1)
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives <b>tonight by 9PM</b>. Choose <b>Same Day</b> during checkout. Order in ${cutOffTimeLeft}.</span>
                                </div><br>`
                          );
                        } else {
                        
                        
                        console.log("Valid Date: ",valid_date)
                        if (valid_date == 'Tomorrow'){
                        
                        // local = true, today != sunday, cut off crossed
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives <b>tomorrow</b>. Choose <b>Same Day</b> during checkout.</span>
                                </div><br>`
                          );
                        }else{
                          $("#ResponsePin").html(`
                              <div class="pincodeMsg">
                                <span>Express Delivery Available by <b>${valid_date}</b>, Choose Local Delivery..</span>
                              </div><br>
                            `);
                        }
                      }
                
              }
              // else if(enteredDistrict == 'N/A' ){
              //    $("#ResponsePin").html(
              //         // IF any error, show this message
              //         // Example: Internal server Error 500 from the Azure hosted app (trackorder)
              //         `<div class="NotAva pincodeMsg"><span style="color: maroon;">Please enter a valid pincode.</span></div><br>`
              //       );
              // }
              else{

                
              let nearest_pincode = 560054; // Default value

              // const nearestWarehouse = availableLocations
              //   .map(location => {
              //     const warehouse = data.wh?.find(wh => wh.Pincode === location.pincode);
              //     return {
              //       ...location,
              //       distance: warehouse?.Distance ?? Infinity, // Use Infinity as a fallback for sorting
              //     };
              //   })
              //   .sort((a, b) => a.distance - b.distance)[0];
              
              // if (nearestWarehouse?.pincode?.length > 0) {
              //   nearest_pincode = nearestWarehouse.pincode;
              // }



                let productweight = pincodeDetailsData?.inventory?.ProductWeight ?? 1.5;
                
              
                
                console.log("Nearest Pincode:", nearest_pincode);
                const apiCall1='/apps/trackorder/checkShiprocketDetailsforETD?q='+nearest_pincode+'&pincode='+pincodeDetailsData.pickuppincode_details.Pincode+'&weight='+productweight
                // console.log(apiCall1)
                $.when(ajaxPin(apiCall1, pageTemplate)).then(
                  (data1) => {
                    let holiday_list=data1.holiday_list
                        // if (Array.isArray(data.data["available_courier_companies"])) {
                        //   data.data["available_courier_companies"].map(function (currentValue, index, arr) {
                        //     console.log(currentValue)
                        //   });
                          
                        // }
                    //check it city location is match with the local delivery locations
                    enteredDistrict = data1.data["available_courier_companies"][0]['city'];
                    enteredState = data1.data["available_courier_companies"][0]['state'];
                    console.log("-------------------")
                    console.log(enteredDistrict)
                    console.log(enteredState)
                     try{   
                    isLocallyAvailable = availableLocations.some(location => {
                        const warehouse1 = data.wh.find(wh => wh.Pincode === location.pincode);
                        console.log(warehouse1)
                        return (
                          warehouse1.District === enteredDistrict || enteredDistrict === 'AHMADABAD' ||
                          (enteredState === "DELHI" && warehouse1.State === "DELHI")
                        );
                      });
                      }catch(e){
                       console.log(e)
                        isLocallyAvailable=false;
                      }
                      if(isLocallyAvailable == true  && currentTime.getDay() != 6  ){
                         let checkDate= new Date();
                         const holidays111 = new Set(holiday_list.map(date => new Date(date).toDateString()));
                         console.log("Printing Today Day")
                         console.log(holidays111.has(currentTime.toDateString()))
                         console.log("i am")
                         let valid_date=getNextValidDateLabel(currentTime, holiday_list);
                        checkDate.setDate(currentTime.getDate() + 1)
                        
                                if ( currentTime.getDay() != 0 && cutOffTimeLeft != "" && holidays111.has(currentTime.toDateString()) == false ) { // local = true, today != sunday, cut off pending
                                    console.log(`${cutOffTimeLeft}  for same day delivery` )
                                    console.log(checkDate)
                                   // console.log(cutOffTime.getHours() - ISTTime.getHours() -1)
                                    $("#ResponsePin").html(`<div  class="pincodeMsg">
                                               <span >Arrives <b>tonight by 9PM</b>. Choose <b>Same Day</b> during checkout. Order in ${cutOffTimeLeft}.</span>
                                          </div><br>`
                                    );
                                  } else {// local = true, today != sunday, cut off crossed
                                    
                                    console.log("Valid Date: ",valid_date)
                                    if (valid_date == 'Tomorrow'){
                                    
                                    // local = true, today != sunday, cut off crossed
                                      $("#ResponsePin").html(`<div  class="pincodeMsg">
                                                 <span >Arrives <b>tomorrow</b>. Choose <b>Same Day</b> during checkout.</span>
                                            </div><br>`
                                      );
                                    }else{
                                      $("#ResponsePin").html(`
                                          <div class="pincodeMsg">
                                            <span>Express Delivery Available by <b>${valid_date}</b>, Choose Local Delivery.</span>
                                          </div><br>
                                        `);
                        }
                                }
                      
                        }
                    else{
                      
      
                      if (found_pincode_in_heavy == true &&(typeof pincodeDetailsData.inventory.ProductType !== "undefined" && (pincodeDetailsData.inventory.ProductType === 'Monitor' || pincodeDetailsData.inventory.ProductType === 'Laptop Battery' || pincodeDetailsData.inventory.ProductType === 'Laptop' || pincodeDetailsData.inventory.ProductType === 'Desktop PC'))){

                        console.log("Heavy Product Logic Applied")  
                          let fastestDate = new Date();
                         fastestDate.setDate(fastestDate.getDate() + 3);
                           if (currentTime.getDay() == 0 ) {
                              console.log("Add Sunday padding and holiday padding");
                              fastestDate.setDate(fastestDate.getDate() + 1); // Add an extra day
                            }
                          parsedDate = days[fastestDate.getDay()] + ", " + months[fastestDate.getMonth()] + " " + fastestDate.getDate();
                         // STEP 3: Check cut-off time for same-day delivery
                          if (cutOffTimeLeft != "") {
                            console.log(`${cutOffTimeLeft} for same-day delivery`);
                            
                            // Display message with cut-off time
                            $("#ResponsePin").html(`
                              <div class="pincodeMsg">
                                <span><b>Express</b> delivery by <b>${parsedDate}</b>${cutOffTimeLeft ? " if ordered in " + `<b>${cutOffTimeLeft}</b>` : ""}</span>
                              </div><br>
                            `);
                          } else {
                            // Display message without cut-off time
                            $("#ResponsePin").html(`
                              <div class="pincodeMsg">
                                <span><b>Express</b> delivery by <b>${parsedDate}</b>.</span>
                              </div><br>
                            `);
                          }
                          
                        
                      }
                        else{
                          // console.log(pincodeDetailsData)
                    let courierAll = filterCourierDays(data1.data["available_courier_companies"], pincodeDetailsData.inventory.ProductType);

                          console.log(courierAll)
                          let parsedDate;
                          
                          if (courierAll.min) {
                            // STEP 1: Get today's date
                            let fastestDate = new Date();
                            
                            // Add the minimum delivery days to the current date
                            fastestDate.setDate(fastestDate.getDate() + courierAll.min);
                            // console.log("Fastest Date:", fastestDate);
                          
                            // STEP 2: Add Sunday padding if today is Sunday
                            if (currentTime.getDay() == 0 ) {
                              console.log("Add Sunday padding and holiday padding");
                              fastestDate.setDate(fastestDate.getDate() + 1); // Add an extra day
                            }
                            console.log("Final Fastest Date:", fastestDate);
                          
                            // Format the date as "Day, Month Date"
                            parsedDate = days[fastestDate.getDay()] + ", " + months[fastestDate.getMonth()] + " " + fastestDate.getDate();
                          } else {
                            // Use the default delivery date if minimum days are not available
                            parsedDate = courierAll.minDate;
                          }
                          
                          // console.log("Parsed Date:", parsedDate);
                          
                          // STEP 3: Check cut-off time for same-day delivery
                          if (cutOffTimeLeft != "") {
                            console.log(`${cutOffTimeLeft} for same-day delivery`);
                            
                            // Display message with cut-off time
                            $("#ResponsePin").html(`
                              <div class="pincodeMsg">
                                <span><b>Express</b> delivery by <b>${parsedDate}</b>${cutOffTimeLeft ? " if ordered in " + `<b>${cutOffTimeLeft}</b>` : ""}</span>
                              </div><br>
                            `);
                          } else {
                            // Display message without cut-off time
                            $("#ResponsePin").html(`
                              <div class="pincodeMsg">
                                <span><b>Express</b> delivery by <b>${parsedDate}</b>.</span>
                              </div><br>
                            `);
                          }
                          
                        }
                    
                    
                    }   
                    
                    
                  },(err) => {
                    $("#ResponsePin").html(
                      // IF any error, show this message
                      // Example: Internal server Error 500 from the Azure hosted app (trackorder)
                      `<div class="NotAva pincodeMsg"><span style="color: maroon;">Looks like wrong pincode.</span></div><br>`
                    );
                  
                  
                  }
                );
              }
                
          },(err) => {
              count=count+1;
              console.log("Pincode Error: ",err)
              
              if (count>4){  
                $("#ResponsePin").html(
                        // IF any error, show this message
                        // Example: Internal server Error 500 from the Azure hosted app (trackorder)
                        `<div class="NotAva pincodeMsg"><span style="color: maroon;">Sorry, we hit an error! Try chat support for help.</span></div><br>`
                );
              }else{
                console.log("Count : ",count)
                getPincodeDetails(count)
              }
                  
                  }
          );

    }
}








// Validate_gst_number_for_Drawer_cart
function validate_gst_number_for_drawer_cart_page(){
    var val = document.getElementById('CartDrawer-addition_note').value;
    gst_lines = val.toUpperCase();
   // console.log(gst_lines)
   
      if(gst_regex.test(gst_lines) == false)
      {
        // if Invalid
        // alert ('Invalid input: ' + lines[i] + '.  Please write the usernames in the correct format (with a full stop between first and last name).');
        $('#CartDrawer-addition_note').css({   
            'border': '3px solid red',
            'border-radius': '5px'
        })
        return false;
      } 
    
    // if Success
    $('#CartDrawer-Checkout').css({
        'pointer-event': 'auto',
        'opacity': '1'
      }).prop('disabled', false)
    
    $('#CartDrawer-addition_note').css({   
            'border': '3px solid black',
            'border-radius': '5px'
        })
 }

// Cart Drawer Discount
  async function pef_drawer_Discount(){
    let data1=[]
   
    let myArray=[]
    for (let i=0;i<document.getElementsByClassName("cart-item__details").length;i++){
        // console.log(document.getElementsByClassName("cart-item__details")[i].title)
        myArray.push(document.getElementsByClassName("cart-item__details")[i].title)
      // console.log(document.getElementsByClassName("cart-item__details")[i].title)
        
        // console.log(i)
        // console.log(document.getElementsByClassName("cart-item__details").length)
    }
    var foundSomeDiscountCoupon=false
    for(i in myArray){
    if (myArray[i].length>1){
      // console.log(myArray[i]);
       let apiCall ="/apps/trackorder/discount?productId=" +myArray[i];
       // console.log(apiCall)
       $.when(ajaxDiscount(apiCall, pageTemplate)).then(
                      (data) => {
                        // console.log("Print Response Data")
                        if (data.length >0){
                          for(i11 in data ){
                            data1.push(data[i11])
                          }
                          // console.log(data)
                        }
                        final_discount_according_data=``
                         var final_discount_data=`<div class="DiscountMsg"> `
                var discount_code=[]
                var discount_message=[]
                // console.log(data)
                var discount_details=data1
                if (discount_details.length > 0){
                  foundSomeDiscountCoupon=true
                  
                     document.getElementById("drawer-discount-offer-coupon-area").style.display='block';
                  // document.getElementById("discountOfferLabel").innerHTML=discount_details.length +' Offers Available:'
                  var discount_label_count=0
                  document.getElementById("drawer-discount-accrodian-collapsible").innerHTML=discount_details.length +' Offers Available'
                  
                  for (let index = 0; index < discount_details.length; index++) {
                    
                   if (discount_code.indexOf(discount_details[index].code) < 0){
                      discount_label_count=discount_label_count+1
                     discount_code.push(discount_details[index].code)
                    let off=0
                    if(discount_details[index].off){
                      off=discount_details[index].off
                      if(off.indexOf('₹')!=-1){
                         off=off.slice(0,off.indexOf('.'))
                        }
                      // console.log(off)
                    }
                    let min_price=discount_details[index].min_purchase_price
                    if (min_price!=null){
                       // console.log(min_price)
                       if(min_price.indexOf('₹')!=-1){
                         // console.log(min_price)
                      min_price=min_price.slice(min_price.indexOf('₹'),min_price.indexOf('.'))
                      min_price=Math.floor(min_price)
                         // console.log(min_price)
                      min_price=kFormatter(min_price)
                       }
                      else{
                        min_price=min_price.slice(0,min_price.indexOf('.'))
                        min_price=Math.floor(min_price)
                         // console.log(min_price)
                        min_price=kFormatter(min_price)
                      }
                    }

                  if(discount_details[index].type == 'bxgy_spen_discount_get_free' && discount_details[index].min_purchase_price != null){
                        final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get Free <strong>${discount_details[index].product_type}</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                  else if (discount_details[index].min_purchase_price != null && discount_details[index].min_quantity == null){
                      final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity == '1'){
                        final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity != '1'){
                      final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${discount_details[index].min_quantity} Qty</strong></p>`
                    }
                   else{
                       final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }
                   }
                  }
                  // console.log(final_discount_according_data)
                   document.getElementById("drawer-discount-accrodian-collapsible").innerHTML=discount_label_count +' Offers Available'
                  $("#drawer-discount-accrodian-content").html(final_discount_according_data)                  
                  // document.getElementById("drawer-discount-accrodian-collapsible").classList.toggle("active")
                  // document.getElementById("drawer-discount-accrodian-content").style.maxHeight=document.getElementById("drawer-discount-accrodian-content").scrollHeight+'px'

                  $("#ResponseDiscount").html(final_discount_data)
                }
            });
    }
  }
    if (foundSomeDiscountCoupon == false){
      document.getElementById("drawer-discount-offer-coupon-area").style.display='none';
    }
  }

// Drawer Cart Note
$("#CartDrawer-addition_note").on("input", function () {
 
    document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.trim();
    var val = document.getElementById('CartDrawer-addition_note').value;
    gst_lines = val.toUpperCase();
    document.getElementById('CartDrawer-addition_note').value=gst_lines
    if ($('#CartDrawer-addition_note').val().length >= 15)  {
      validate_gst_number_for_drawer_cart_page()
      document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.slice(0, 15)
    }
    else{
       // console.log('true')
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
    }
  })


//Interval for Drawer Cart Offer Update
 setInterval(function () {
   if(discountOfferDrawerCartItemCount != $("tr[id^=CartDrawer-Item]").length){

     // GST Condition
     discountOfferDrawerCartItemCount=$("tr[id^=CartDrawer-Item]").length;
     document.getElementById("drawer-discount-accrodian-collapsible").addEventListener("click", function() {
      console.log("Offer DD")
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
      $('#GST_Order_CheckBox_Drawer').on('click', function () {
      if(document.getElementById("GST_Order_CheckBox_Drawer").checked == false){
        document.getElementById('Details-additional-CartDrawer').style.display = 'none';
        $('#CartDrawer-Checkout').css({
          'pointer-event': 'auto',
          'opacity': '1'
        }).prop('disabled', false)
      }else{
        document.getElementById('Details-additional-CartDrawer').style.display='block';
        $('#CartDrawer-Checkout').css({
          'pointer-event': 'none',
          'opacity': '0.5'
        }).prop('disabled', true)
        validate_gst_number_for_drawer_cart_page()
      }
       
        // GST Oninput Function
        $("#CartDrawer-addition_note").on("input", function () {
       
          document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.trim();
          var val = document.getElementById('CartDrawer-addition_note').value;
          gst_lines = val.toUpperCase();
          document.getElementById('CartDrawer-addition_note').value=gst_lines
          if ($('#CartDrawer-addition_note').val().length >= 15)  {
            validate_gst_number_for_drawer_cart_page()
            document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.slice(0, 15)
          }
          else{
             // console.log('true')
            $('#CartDrawer-Checkout').css({
              'pointer-event': 'none',
              'opacity': '0.5'
            }).prop('disabled', true)
          }
        })
        });
      // Discount Offer Reload
      pef_drawer_Discount();
   }
   else if(discountOfferDrawerCartItemCount >0 && document.getElementById("drawer-discount-accrodian-content").childElementCount ==0){
         // GST Condition
     discountOfferDrawerCartItemCount=$("tr[id^=CartDrawer-Item]").length;

     document.getElementById("drawer-discount-accrodian-collapsible").addEventListener("click", function() {
      console.log("Offer ND")
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        } 
      });
      $('#GST_Order_CheckBox_Drawer').on('click', function () {
    if(document.getElementById("GST_Order_CheckBox_Drawer").checked == false){
      document.getElementById('Details-additional-CartDrawer').style.display = 'none';
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'auto',
        'opacity': '1'
      }).prop('disabled', false)
    }else{
      document.getElementById('Details-additional-CartDrawer').style.display='block';
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
      validate_gst_number_for_drawer_cart_page()
    }
    });

// GST Input Function
 $("#CartDrawer-addition_note").on("input", function () {
 
    document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.trim();
    var val = document.getElementById('CartDrawer-addition_note').value;
    gst_lines = val.toUpperCase();
    document.getElementById('CartDrawer-addition_note').value=gst_lines
    if ($('#CartDrawer-addition_note').val().length >= 15)  {
      validate_gst_number_for_drawer_cart_page()
      document.getElementById('CartDrawer-addition_note').value=document.getElementById('CartDrawer-addition_note').value.slice(0, 15)
    }
    else{
       // console.log('true')
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
    }
  });

// Discount Offer
pef_drawer_Discount();    
   }
 }, 3000);


//Hide and Show Enter GST no on Cart Drawer Page
 $('#GST_Order_CheckBox_Drawer').on('click', function () {
    if(document.getElementById("GST_Order_CheckBox_Drawer").checked == false){
      document.getElementById('Details-additional-CartDrawer').style.display = 'none';
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'auto',
        'opacity': '1'
      }).prop('disabled', false)
    }else{
      document.getElementById('Details-additional-CartDrawer').style.display='block';
      $('#CartDrawer-Checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
      validate_gst_number_for_drawer_cart_page()
    }
});


//Find Discount offers  
function kFormatter(num) {
  if (num > 99999) {
    return '₹' + Math.floor(num / 100000) + 'L';
  } else if (num > 999) {
    return '₹' + Math.floor(num / 1000) + 'K';
  } else {
    return num;
  }
}


// MVP point modal
async function mvp_display(){
		document.getElementById('mvpmodal').classList.toggle('mvp_fade')
		setTimeout(function(){document.getElementById('mvp_modal_area').classList.toggle('mvp_modal_area_show')}, 3)
        document.getElementById('slid-right-mvp-btn').style.display='none'
	}
async function mvp_display_hide(){
    document.getElementById('mvp_modal_area').classList.toggle('mvp_modal_area_show')
    await new Promise(resolve => setTimeout(resolve, 500));
    document.getElementById('mvpmodal').classList.toggle('mvp_fade')
    document.getElementById('slid-right-mvp-btn').style.display='flex'
  }


// AJAX API call
function ajaxPin(url, template, orderID) {
  return $.ajax({
    url: url,
    cache: false,
    async: true,
    beforeSend: function () {
      // console.log('before');
      if (template == "product") {
        $("#ResponsePin").html('<div class="pincodeMsg">Loading Delivery Timeline ...</div>');
        
      }
    },
    complete: function (data) {
        console.log('complete');
    },
  });
}

//AJAX API call for Discount Offer
function ajaxDiscount(url, template) {
  return $.ajax({
    url: url,
    cache: false,
    async: true,
    beforeSend: function () {
      // console.log('before');
      if (template == "product") {
        $("#ResponseDiscount").html('<div class="DiscountMsg"></div>');
        // $("#ResponseDiscount").addClass("loader_gif");
      }
    },
    complete: function (data) {
      //   console.log('complete');
      // $("#ResponseDiscount").removeClass("loader_gif");
    },
  });
}


// If page Template is Search  and Not Product Page
if(pageTemplate == 'search' && pageTemplate !='product'){
  document.getElementById("popup_order_message_div").classList.add("search__recent_order_bar")
}

if (window.innerWidth < 700 && pageTemplate == 'index'){
document.getElementById("popup_order_message_div").style.display = 'none'
}else{
  document.getElementById("popup_order_message_div").style.display = ''
}

if(pageTemplate == 'cart'){
  //Cart GST Input Function and validation 
  var gst_lines='';
  function validate_gst_number_for_cart_page() {
      var val = document.getElementById('Cart-addition_note').value.trim().toUpperCase();
      document.getElementById('Cart-addition_note').value = val;
  
      var gst_regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  
      if (!gst_regex.test(val)) {
          $('#Cart-addition_note').css({
              'border': '3px solid red',
              'border-radius': '5px'
          });
          return false;
      }
  
      $('#checkout').css({
          'pointer-events': 'auto',
          'opacity': '1'
      }).prop('disabled', false);
  
      $('#Cart-addition_note').css({
          'border': '3px solid black',
          'border-radius': '5px'
      });
  
      return true;
  }

//Hide and Show Enter GST no on Cart Page
 $('#GST_Order_CheckBox').on('click', function () {
    if(document.getElementById("GST_Order_CheckBox").checked == false){
      document.getElementById('cart_note_gst').style.display = 'none';
      $('#checkout').css({
        'pointer-event': 'auto',
        'opacity': '1'
      }).prop('disabled', false)
    }else{
      document.getElementById('cart_note_gst').style.display='block';
      $('#checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
      validate_gst_number_for_cart_page()
    }
});
  
$("#Cart-addition_note").on("input", function () {
 
    document.getElementById('Cart-addition_note').value=document.getElementById('Cart-addition_note').value.trim();
     
    if ($('#Cart-addition_note').val().length >= 15)  {
      validate_gst_number_for_cart_page()
      document.getElementById('Cart-addition_note').value=document.getElementById('Cart-addition_note').value.slice(0, 15)
    }
    else{
       console.log('true')
      $('#checkout').css({
        'pointer-event': 'none',
        'opacity': '0.5'
      }).prop('disabled', true)
    }
  })



  
  // Call Discount Function

  pef_Discount()
  setInterval(function () {
    if(discountOfferCartItemCount != $("tr[id^=CartItem]").length){
      pef_Discount();
      discountOfferCartItemCount=$("tr[id^=CartItem]").length;
       document.getElementById("discount-accrodian-collapsible").addEventListener("click", function() {
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
            
          }
          
        });
      
    }}, 5000);




  async function pef_Discount(){
    let data1=[]
   
    let myArray=[]
    for (let i=0;i<document.getElementsByClassName("cart-item__details").length;i++){
        // console.log(document.getElementsByClassName("cart-item__details")[i].title)
        myArray.push(document.getElementsByClassName("cart-item__details")[i].title)
        
        // console.log(i)
        // console.log(document.getElementsByClassName("cart-item__details").length)
    }
    var foundSomeDiscountCoupon=false
    for(i in myArray){
    if (myArray[i].length>1){
      // console.log(myArray[i]);
       let apiCall ="/apps/trackorder/discount?productId=" +myArray[i];
       // console.log(apiCall)
       $.when(ajaxDiscount(apiCall, pageTemplate)).then(
                      (data) => {
                        // console.log("Print Response Data")
                        if (data.length >0){
                          for(i11 in data ){
                            data1.push(data[i11])
                          }
                          // console.log(data)
                        }
                        final_discount_according_data=``
                         var final_discount_data=`<div class="DiscountMsg"> `
                var discount_code=[]
                var discount_message=[]
                // console.log(data)
                var discount_details=data1
                if (discount_details.length > 0){
                  
                  document.getElementById("discount-offer-coupon-area").style.display = 'block'
                  foundSomeDiscountCoupon=true
                  // document.getElementById("discountOfferLabel").innerHTML=discount_details.length +' Offers Available:'
                  var discount_label_count=0
                  document.getElementById("discount-accrodian-collapsible").innerHTML=discount_details.length +' Offers Available'
                  
                  for (let index = 0; index < discount_details.length; index++) {
                    
                   if (discount_code.indexOf(discount_details[index].code) < 0){
                      discount_label_count=discount_label_count+1
                     discount_code.push(discount_details[index].code)
                    let off=0
                    if(discount_details[index].off){
                      off=discount_details[index].off
                      if(off.indexOf('₹')!=-1){
                         off=off.slice(0,off.indexOf('.'))
                        }
                      // console.log(off)
                    }
                    let min_price=discount_details[index].min_purchase_price
                    if (min_price!=null){
                       // console.log(min_price)
                       if(min_price.indexOf('₹')!=-1){
                         // console.log(min_price)
                      min_price=min_price.slice(min_price.indexOf('₹'),min_price.indexOf('.'))
                      min_price=Math.floor(min_price)
                         // console.log(min_price)
                      min_price=kFormatter(min_price)
                       }
                      else{
                        min_price=min_price.slice(0,min_price.indexOf('.'))
                        min_price=Math.floor(min_price)
                         // console.log(min_price)
                        min_price=kFormatter(min_price)
                      
                      }
                    }


                      if(discount_details[index].type == 'bxgy_spen_discount_get_free' && discount_details[index].min_purchase_price != null){
                        final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get Free <strong>${discount_details[index].product_type}</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                  else if (discount_details[index].min_purchase_price != null && discount_details[index].min_quantity == null){
                      final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity == '1'){
                        final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity != '1'){
                      final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${discount_details[index].min_quantity} Qty</strong></p>`
                    }
                   else{
                       final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }


                     
                   }
                  }
                  // console.log(final_discount_according_data)
                   document.getElementById("discount-accrodian-collapsible").innerHTML=discount_label_count +' Offers Available'
                  $("#discount-accrodian-content").html(final_discount_according_data)
                  
                  document.getElementById("discount-accrodian-collapsible").classList.toggle("active")
                  document.getElementById("discount-accrodian-content").style.maxHeight=document.getElementById("discount-accrodian-content").scrollHeight+'px'
                    
                  $("#ResponseDiscount").html(final_discount_data)



                  
                }
                        
            });
    
    }

      if (foundSomeDiscountCoupon == false){
        document.getElementById("discount-offer-coupon-area").style.display = 'none'
      }
      
 
  }
  

  }



}











//  Product page Javascript
if (pageTemplate == 'product' ){
     // document.getElementById("discount-accrodian-collapsible").addEventListener("click", function() {
     //    this.classList.toggle("active");
     //    var content = this.nextElementSibling;
       
     //    if (content.style.maxHeight){
     //      content.style.maxHeight = null;
     //    } else {
     //      content.style.maxHeight = content.scrollHeight + "px";
     //    } 
     //  });
// // Call Discount Function
// document.getElementById("discountOfferSlideLeft").style.display='none';
// document.getElementById("discountOfferSlideRight").style.display='none';
pef_Discount()
  
// On keypress event of pincode 
$("#textpincodevalue").on("keypress", function (e) {
  var key = e.keyCode;
  if (key < 48 || key > 57) {
    e.preventDefault();
  }
    let enteredPincode = $("#textpincodevalue").val();
    // Storing pincode in cookie
    // localStorage.setItem("enteredPincode", enteredPincode);
    if (parseInt(enteredPincode) == 0) {
      e.preventDefault();
    }
    if (e.which == 13) {
       // console.log('enter press');
       e.preventDefault();
       getPincodeDetails();
    }
  });

//On button click of pincode  
$("#pincode").click(function () {
    getPincodeDetails();
});

// filter the courier and return estimated deliver days
function filterCourierDays(object, productType) {  
  // var arrayObj = [];
  // object.map(function (currentValue, index, arr) {
  //           console.log(currentValue)
  //           console.log("Filtered courier days: " + currentValue.etd + " | " + currentValue.courier_name);
  //            if(productType == 'Cabinet' || productType == 'Gaming Chair' || productType == 'Monitor' || productType=='Laptop Battery'){
  //              // 0 is surface mode
  //             if(currentValue.mode == 0){
  //               arrayObj[currentValue.courier_name.toLowerCase()] = {
  //               days: parseInt(currentValue.estimated_delivery_days),
  //               date: currentValue.etd,
  //               suppression_dates: currentValue.suppression_dates,
  //               mode: currentValue.mode
  //               }
  //               console.log(arrayObj)
  //             }
  //           } else{
  //             arrayObj[currentValue.courier_name.toLowerCase()] = {
  //             days: parseInt(currentValue.estimated_delivery_days),
  //             date: currentValue.etd,
  //             suppression_dates: currentValue.suppression_dates,
  //             mode: currentValue.mode
  //             }
  //           }
  //         });
    var arrayObj = {};  // Changed to an object
    
    // Ensure 'object' is an array before calling map()
    if (Array.isArray(object)) {
      object.map(function (currentValue, index, arr) {
        //console.log(currentValue);
        //console.log("Filtered courier days: " + currentValue.etd + " | " + currentValue.courier_name);
        // console.log(productType)
        if (typeof productType !== "undefined" &&
            (productType === 'Monitor' || productType === 'Laptop Battery' || productType === 'Laptop' || productType === 'Desktop PC')) {
            // (productType === 'Cabinet' || productType === 'Gaming Chair' || productType === 'Monitor' || productType === 'Laptop Battery')) {
          // console.log(currentValue.mode)
          // Ensure mode property exists and check condition
          if (currentValue.mode === 0) {
            let courierName = currentValue.courier_name ? currentValue.courier_name.toLowerCase() : "unknown";
            arrayObj[courierName] = {
              days: parseInt(currentValue.estimated_delivery_days, 10),
              date: currentValue.etd,
              suppression_dates: currentValue.suppression_dates,
              mode: currentValue.mode
            };
            //console.log(arrayObj);
          }
        } else {
          let courierName = currentValue.courier_name ? currentValue.courier_name.toLowerCase() : "unknown";
          arrayObj[courierName] = {
            days: parseInt(currentValue.estimated_delivery_days, 10),
            date: currentValue.etd,
            suppression_dates: currentValue.suppression_dates,
            mode: currentValue.mode
          };
        }
      });
    } else {
      console.error("Error: 'object' is not an array");
    }
          var list = arrayObj;
         // console.log(arrayObj)
          var keys = Object.keys(list);
          var min = list[keys[0]].days;
          var max = list[keys[0]].days;
          var minDate = list[keys[0]].date;
          var maxDate = list[keys[0]].date;
          var suppression_dates = list[keys[0]].suppression_dates;
          var i;
          // console.log("-------------------------")
        //  console.log(list);
          // console.log(min);
          // console.log(max);
          // console.log("-------------------------")
          // console.log(list)
          for (i = 1; i < keys.length; i++) {
            var value = list[keys[i]];
           if (value.days>0){
              //  console.log(value);
              if (value.days < min) {
                //	console.log(value);
                // console.log(value)
                min = value.days;
                minDate = value.date;
                suppression_dates = value.suppression_dates;
              }
              if (value.days > max) {
                // console.log(value);
                max = value.days;
                maxDate = value.date;
                // suppression_dates = value.suppression_dates;
              }
           }
          }
    if (suppression_dates == null){
      suppression_dates=[]
    }
        
          return {
            
            min: min,
            max: max,
            minDate: minDate,
            maxDate: maxDate,
            suppression_dates: suppression_dates,
          };
}


//Previous code for Discount Coupon  
// function pef_Discount(){
//   let apiCall =
//             "/apps/trackorder/discount?productId=" +
//             $("#discountOfferContainer")[0].title;
//   console.log(apiCall)
//   $.when(ajaxDiscount(apiCall, pageTemplate)).then(
//               (data) => {
//                 var final_discount_data=`<div class="DiscountMsg"> `
//                 var discount_code=[]
//                 var discount_message=[]
//                 console.log(data)
//                 var discount_details=data
//                 if (discount_details.length > 0){
//                   document.getElementById("discountOfferLabel").innerHTML=discount_details.length +' Offers Available:'
                  
//                   for (let index = 0; index < discount_details.length; index++) {
//                     let off=0
//                     if(discount_details[index].off){
//                       off=discount_details[index].off
//                       if(off.indexOf('₹')!=-1){
//                          off=off.slice(0,off.indexOf('.'))
//                         }
//                       console.log(off)
//                     }
//                     let min_price=discount_details[index].min_purchase_price
//                     if (min_price!=null){
//                        console.log(min_price)
//                        if(min_price.indexOf('₹')!=-1){
//                          console.log(min_price)
//                       min_price=min_price.slice(min_price.indexOf('₹'),min_price.indexOf('.'))
//                       min_price=Math.floor(min_price)
//                          console.log(min_price)
//                       min_price=kFormatter(min_price)
//                        }
//                       else{
//                         min_price=min_price.slice(0,min_price.indexOf('.'))
//                         min_price=Math.floor(min_price)
//                          console.log(min_price)
//                         min_price=kFormatter(min_price)
                      
//                       }
//                     }

//                     final_discount_data+=`<div class="cardContainer"><div class="card ">
//                     <div class="cardContainerText">
//                     <p> `
                    
//                     console.log('--------------------------------------')
//                     console.log(discount_details[index])
//                     console.log('---------------------------------------')
//                     if(discount_details[index].type == 'bxgy_spen_discount_get_free' && discount_details[index].min_purchase_price != null){
//                         final_discount_data+='Get Free  <a href="'+discount_details[index].free_item_url+'" title="'+discount_details[index].free_item+'" target="_blank">'+discount_details[index].product_type+'</a>  on min purchase of '+min_price+' </p><div class="couponCodeArea"><b>Coupon Code:</b><br><h4 class="couponCode " ><b>'
                      
//                     final_discount_data+=discount_details[index].code
//                     final_discount_data+='</b></h4></div></div></div></div>'
//                     }
//                     else if (discount_details[index].min_purchase_price != null && discount_details[index].min_quantity == null){
//                       final_discount_data+='Get '+off + ' Off on min purchase of '+min_price+' </p><div class="couponCodeArea"><b>Coupon Code:</b><br><h4 class="couponCode " ><b>'
                      
//                     final_discount_data+=discount_details[index].code
//                     final_discount_data+='</b></h4></div></div></div></div>'
                      
//                     }
//                      else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity == '1'){
//                       final_discount_data+='Get Flat '+off + ' Off '+' on this product </p><div class="couponCodeArea"><b>Coupon Code:</b><br><h4 class="couponCode"><b>'
                      
//                     final_discount_data+=discount_details[index].code
//                     final_discount_data+='</b></h4></div></div></div></div>'
                     
//                     }
//                     else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity != '1'){
//                       final_discount_data+='Get Flat '+off+ ' Off on min purchase of minimum '+discount_details[index].min_quantity+' Quantity'+' </p><div class="couponCodeArea"><b>Coupon Code:</b><br><h4 class="couponCode"><b>'
                      
//                     final_discount_data+=discount_details[index].code
//                     final_discount_data+='</b></h4></div></div></div></div>'
                     
//                     }
//                     else{
//                      final_discount_data+='Get Flat '+off+ ' Off on this product'+' </p><div class="couponCodeArea"><b>Coupon Code:</b><br><h4 class="couponCode"><b>'
                      
//                     final_discount_data+=discount_details[index].code
//                     final_discount_data+='</b></h4></div></div></div></div>'
//                     }
                    
//                   }
//                   final_discount_data+=`</div>        `
//                   $("#ResponseDiscount").html(final_discount_data)
//                    if (discount_details.length > 3){
//                   document.getElementById("discountOfferSlideLeft").style.display='none';
//                   document.getElementById("discountOfferSlideRight").style.display='';
//                   }
//                 }else{
//                    document.getElementById("discountOfferLabel").innerHTML=''
//                 }
                
//               });
// }





function pef_Discount(){

  let apiCall =
            "/apps/trackorder/discount?productId=" +
            $("#discountOfferContainer")[0].title;
  // console.log(apiCall)
  $.when(ajaxDiscount(apiCall, pageTemplate)).then(
              (data) => {
                // final_discount_according_data=``
                var final_discount_according_data1=``;
                var count=0;
                var discount_code=[];
                var discount_message=[];
                // console.log(data)
                var discount_details=data
                if (discount_details.length > 0){
                  
                  // document.getElementById("discount-offer-coupon-area").style.display='block';
                  // document.getElementById("discount-accrodian-collapsible").innerHTML=discount_details.length +' Offers Available';
                  document.getElementById("discount_offer_title").innerHTML='<strong>Available Offers</strong>';
                  for (let index = 0; index < discount_details.length; index++) {
                    count=count+1
                    let off=0
                    if(discount_details[index].off){
                      off=discount_details[index].off
                      if(off.indexOf('₹')!=-1){
                         off=off.slice(0,off.indexOf('.'))
                        }
                      // console.log(off)
                    }
                    let min_price=discount_details[index].min_purchase_price
                    if (min_price!=null){
                       // console.log(min_price)
                       if(min_price.indexOf('₹')!=-1){
                         // console.log(min_price)
                      min_price=min_price.slice(min_price.indexOf('₹'),min_price.indexOf('.'))
                      min_price=Math.floor(min_price)
                         // console.log(min_price)
                      min_price=kFormatter(min_price)
                       }
                      else{
                        min_price=min_price.slice(0,min_price.indexOf('.'))
                        min_price=Math.floor(min_price)
                         // console.log(min_price)
                        min_price=kFormatter(min_price)
                      
                      }
                    }
                  if(discount_details[index].type == 'bxgy_spen_discount_get_free' && discount_details[index].min_purchase_price != null){
                        // final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get Free <strong>${discount_details[index].product_type}</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                        final_discount_according_data1+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get Free <strong>${discount_details[index].product_type}</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                  else if (discount_details[index].min_purchase_price != null && discount_details[index].min_quantity == null){
                      // final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                      final_discount_according_data1+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${min_price}</strong></p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity == '1'){
                        // final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                        final_discount_according_data1+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }
                   else if (discount_details[index].min_purchase_price == null && discount_details[index].min_quantity != null && discount_details[index].min_quantity != '1'){
                      // final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${discount_details[index].min_quantity} Qty</strong></p>`
                      final_discount_according_data1+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${discount_details[index].min_quantity} Qty</strong></p>`
                    }
                   else{
                       // final_discount_according_data+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                       final_discount_according_data1+=`<p>Coupon: <strong>${discount_details[index].code}</strong> Get <strong>${off} Off</strong> on this product </p>`
                    }
                  }
                  console.log(count)
                  if(count<3){
                    $("#main_offers").html(final_discount_according_data1)
                    document.getElementById("toggle_discount_offers").style.display='none';
                  }
                  else{
                    document.getElementById("toggle_discount_offers").innerHTML=`+`+count-2 +' more Offer';   
                    document.getElementById("toggle_discount_offers").style.display='block';   
                    $("#hidden_offers").html(final_discount_according_data1)
                  }
                  // $("#discount-accrodian-content").html(final_discount_according_data)
                  // document.getElementById("discount-accrodian-collapsible").classList.toggle("active")
                  // document.getElementById("discount-accrodian-content").style.maxHeight=document.getElementById("discount-accrodian-content").scrollHeight+'px'
                  // $("#ResponseDiscount").html(final_discount_data)
              }
                else{
                   // document.getElementById("discount-offer-coupon-area").style.display='none';
                  document.getElementById("discount_offer_area1").style.display='none';
                  }
              });
}
// // Customer Fucntion to Scroll Discount Offer 
//   document.getElementById("discountOfferSlideLeft").onclick = function() {    
//     document.getElementById('OfferScrollArea').scrollLeft-=document.getElementsByClassName('cardContainer')[0].clientWidth+10;
//     document.getElementById("discountOfferSlideRight").style.display='';
//     if(document.getElementById('OfferScrollArea').scrollWidth/document.getElementById('OfferScrollArea').scrollLeft  == Infinity){
//       document.getElementById("discountOfferSlideLeft").style.display='none';
//         document.getElementById("discountOfferSlideRight").style.display='';
//     }
//   };
//   document.getElementById("discountOfferSlideRight").onclick = function() {
//     document.getElementById('OfferScrollArea').scrollLeft+=document.getElementsByClassName('cardContainer')[0].clientWidth;
//     document.getElementById("discountOfferSlideLeft").style.display=''
//      if(parseInt(document.getElementById('OfferScrollArea').scrollWidth-(document.getElementById('OfferScrollArea').scrollLeft+document.getElementById('OfferScrollArea').offsetWidth)) == 0){
//         document.getElementById("discountOfferSlideLeft").style.display='';
//         document.getElementById("discountOfferSlideRight").style.display='none';
//     }
//   };

// PINCODE & SHIPPING
function pef_Pincode() {
          let enteredPincode = $("#textpincodevalue").val();
          localStorage.setItem("enteredPincode", enteredPincode);
          let apiCall =
            "/apps/trackorder/pincode?q=" +
            $("#textpincodevalue").val() +
            "&productId=" +
            document.getElementById('pincodeContainer').title;
          //console.log(apiCall)
          // Validate pincode must be 6 numbers only, without shooting API
          if (enteredPincode.length != 6) {
            // Alert if pincode is not entered at all
            if (enteredPincode.length == 0) {
              $("#ResponsePin").html(
                '<div class="NotAva"></div>'
              );
            }
            // If wrong pincode is entered ( 0 < characters < 6)            
            else {
              $("#ResponsePin").html(
                '<div class="NotAva"><p >Looks like wrong pincode.</p></div>'
              );
            }
          }
          // If pincode is 6 digits number, let us process API's response
          else {
            $.when(ajaxPin(apiCall, pageTemplate)).then(
              (data) => {
                // SHIPROCKET Success Loop
                if (data.status == 200) {
                  // START: SETUP variables of cut-off time for same day dispatch or not
                  var currentTime = new Date();
                  var currentDay=currentTime.getDay()
                  var currentOffset = currentTime.getTimezoneOffset();
                  var ISTOffset = 330; // IST offset UTC +5:30
                  var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);
                  let cutOffTime = new Date(ISTTime)
                        cutOffTime.setHours(14);
                        cutOffTime.setMinutes(0);
                        cutOffTime.setSeconds(0);
                        cutOffTime.setMilliseconds(0);
                  var hoursIST = ISTTime.getHours();
                  let offsetTime = 16 - hoursIST;
                  let cutOffTimeLeft = ""
                  // Handle cutoff time
                  if(cutOffTime.getHours() > ISTTime.getHours()){
                        if(cutOffTime.getHours() - ISTTime.getHours() <=1){
                          cutOffTimeLeft = (60 - ISTTime.getMinutes()) + " min"
                        } else{cutOffTimeLeft = (cutOffTime.getHours() - ISTTime.getHours() ) + " hr"}
                  } else { console.log("Cutoff crossed") }
                  // END: SETUP variables of cut-off time for same day dispatch or not

                  // START: MAIN work of ETD Calculation
                  if (data.value.isBluedart) {
                        // If data coming from Bluedart API?
                        $("#ResponsePin").html(
                          // `<div class="pincodeMsg" style="font-size: 1rem;"><p >Fastest delivery by <b>${data.value.deliveryDate}</b>${cutOffTimeLeft ? " if ordered in "+ `<b>${cutOffTimeLeft}</b>` : "" }</p></div>`
                          `<p>Express delivery by <b>${data.value.deliveryDate}</b>${cutOffTimeLeft ? " if ordered in "+ `<b>${cutOffTimeLeft}</b>` : "" }</p></div><br>`
                        );
                  } else {
                    // If data coming from non-Bluedart
                    let courierAll = filterCourierDays(data.value.data["available_courier_companies"], data.productType);
                    // THE JAVASCRIPT BUILT IN METHODS RETURN MONTH AND DAY INDEX'S, HENCE THE FOLLOWING ARRAYS
                    var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",];
                    var days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat",];
                    
                    // THIS VALUE (parsedDate) WILL BE DISPLAYED FOR DATE ON THE FRONTEND
                    let parsedDate;
                    
                    // START: FILTER FASTED ETD in PARSED_DATE
                    // PICK THE MINIMUM NUMBER OF DAYS IS IN THE RESPONSE (99.99% CASES)
                    if (courierAll.min) {
                      // STEP 1 = GET TODAYS DATE
                      let fastestDate = new Date();
                      // console.log(fastestDate)
                      // STEP 2 = ADD THE MININUM NUMBER OF DAYS IT WILL TAKE TO DELIVER, i.e courierAll.min
                        if(data.value.isVirtual){
                         // console.log("Product is virtual")
                          fastestDate.setDate(fastestDate.getDate() + courierAll.min + 1);  // extra one days in virtual
                         } 
                        else {
                         // console.log("Product is not virtual")
                          //console.log(fastestDate.getDate())
                          // console.log(courierAll.min)
                          fastestDate.setDate(fastestDate.getDate() + courierAll.min);  // Date as it is based on shortest deliver timeline
                          console.log("Fastest "+fastestDate)
                         }
                      // STEP 3 : PARSE THE NEW DATE AND CREATE A DATE STRING USING BUILT IN DATE FUNCTIONS
                      // Also add one more day if today is SUNDAY
                      if(currentDay == 0){
                          console.log("Add Sunday padding")
                          fastestDate.setDate(fastestDate.getDate() +  1);  // extra one days in Sunday
                      }
                      console.log("Final Fastest: " + fastestDate)
                      parsedDate = days[fastestDate.getDay()] + ", " + months[fastestDate.getMonth()] + " " + fastestDate.getDate();
                    } else {
                      // TAKE DEFAULT SHIPROCKET DATE IF MINIMUM NUMBER OF DAYS IS NOT AVAILABLE
                      parsedDate = courierAll.minDate;
                    }
                    // END: FILTER FASTED ETD in PARSED_DATE
                    
                    // No Supression Dates
                    if (courierAll.suppression_dates.length == 0) {
                      
                      var strFirstThree = enteredPincode.substring(0, 3);
                      // If PINCODE is from same location where we have inventory LIVE the show paid express delivery
                      // This options WORKS only for LUCKNOW and BANGALORE as of now
                      console.log("Locally? " + data.isLocallyAvailable)
                      //console.log(data)
                      // 
                       if (data.isLocallyAvailable==true) {
                           // Local Delivery Within Cut-off time
                            if (data.sameDayDelivery==true && currentDay != 0 && cutOffTimeLeft != "") {
                              $("#ResponsePin").html(
                              `<div class="pincodeMsg">
        							<span ><i>Same Day Delivery</i> available during checkout. Cut off in ${cutOffTimeLeft}.</span>
                              </div><br>`);  
                              } 
                            // Local Delivery Outside Cut-off time
                           else if (data.isLocallyAvailable == true && currentDay != 0 ){
                                $("#ResponsePin").html(
                                  `<div  class="pincodeMsg">
                                           <span style="color: green;">Same Day Delivery</i> available during checkout.</span>
                                      </div><br>`
                              );}
                            // Local Delivery any other case
                              else {
                                  $("#ResponsePin").html(
                                `<div  class="pincodeMsg">
          							<span><b>Express</b> delivery by <b>${parsedDate}</b>.</span>
                                </div><br>`);}
                        } 
                       // Without Local Delivery cases
                       else {
                                  // console.log(data.sameDayDelivery);
                                  $("#ResponsePin").html(
                                      // `<div  class="pincodeMsg" style="font-size: 1rem;"><p ><b>Free </b> fastest delivery by <b>${parsedDate}</b>${cutOffTimeLeft ? " if ordered in "+`<b>${cutOffTimeLeft}</b>` : "" }</p></div>`
                                    `<div><span ><b>Express </b> delivery by <b>${parsedDate}</b>${cutOffTimeLeft ? " if ordered in "+`<b>${cutOffTimeLeft}</b>` : "" }</span></div><br>`
                                  );
                                  // console.log(data.sameDayDelivery)
                        }
                      }
                    // Cases with Supression Dates
                    else {
                        console.log("Locally? " + data.isLocallyAvailable)
                        if (data.isLocallyAvailable == true && currentDay != 0 && cutOffTimeLeft != "") { // local = true, today != sunday, cut off pending
                          console.log(`${cutOffTimeLeft}  for same day delivery` )
                         // console.log(cutOffTime.getHours() - ISTTime.getHours() -1)
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives <b>tonight by 9PM</b>. Choose <b>Same Day</b> during checkout. Order in ${cutOffTimeLeft}.</span>
                                </div><br>`
                          );
                        } else if (data.isLocallyAvailable == true && currentDay != 0 ) {// local = true, today != sunday, cut off crossed
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives <b>tomorrow</b>. Choose <b>Same Day</b> during checkout.</span>
                                </div><br>`
                          );} else if (data.isLocallyAvailable == true && currentDay == 0 ) { // local = true, today = sunday
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives <b>tomorrow</b>. Choose <b>Same Day</b> during checkout.</span>
                                </div><br>`
                          );} else {
                          $("#ResponsePin").html(`<div  class="pincodeMsg">
                                     <span >Arrives by <b>${parsedDate}</b>${cutOffTimeLeft ? " if ordered in "+`<b>${cutOffTimeLeft}</b>` : "" }.</span>
                                </div><br>`);
                          }
                        }
                    } // END: MAIN work of ETD Calculation
                }
      
                // SHIPROCKET Failure Loop
                else {
                  $("#ResponsePin").html(`<div class="NotAva pincodeMsg"><span style="color: maroon;">Unable to fetch info! Try chat support.</span></div><br>`
                  );}
              },
              (err) => {
                 console.log(err);
                if (err.status == 400) {
                  $("#ResponsePin").html(
                    '<div class="NotAva pincodeMsg"><span style="color: maroon;">We cannot find that pincode.</span></div><br>'
                  );
                } else if (err.status == 404) {
                  $("#ResponsePin").html(
                    // IF any error, show this message
                    // Example: Internal server Error 500 from the Azure hosted app (trackorder)
                    `<div class="NotAva pincodeMsg"><span style="color: maroon;">Sorry, we hit an error! Try chat support for help.</span></div><br>`
                  );
                } else {
                  $("#ResponsePin").html(
                    // IF any error, show this message
                    // Example: Internal server Error 500 from the Azure hosted app (trackorder)
                    `<div class="NotAva pincodeMsg"><span style="color: maroon;">Sorry, we hit an error! Try chat support for help.</span></div><br>`
                  );
                }
              }
            );
          }
        }

      // Check weather the geolocation work or not
    function getPostcodeAddessLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showLatLogPosition);
      } else { 
        console.log("Geolocation is not supported by this browser.")
      }
    }
    // Find Lat Long Value
    function showLatLogPosition(position) {
      // console.log("Latitude: " + position.coords.latitude + 
      // "Longitude: " + position.coords.longitude)
      const lat=position.coords.latitude;
      const lon=position.coords.longitude;
          
        try{ 
            let url=`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`; 
            fetch(url).then(res=>res.json()).then( (data) => {
                // console.log(data.address)
               if (data.address.postcode !='undefined' && data.address.postcode.length == 6 ){
                 try{
                    document.getElementById('textpincodevalue').value=data.address.postcode;
                    getPincodeDetails(1);
                 }
                 catch{ console.log(" ")
                 }
                } else{
                     document.getElementById('textpincodevalue').value='560094';
                     getPincodeDetails(1);
                }
               })
            
          } catch(err){
                console.log(err);
                document.getElementById('textpincodevalue').value='560094';
               getPincodeDetails(1);
          }
    }
    
 
    getPostcodeAddessLocation();

}// Close Product page Javascript